import { Checkbox, Chip, TableCell, TableRow, Typography } from "@mui/material";
import { useDataHora } from "../../../core/hooks/useDataHora";
import { useMoeda } from "../../../core/hooks/useMoeda";
import { IConta } from "../../interfaces/IConta";
import { ReferenciaConta } from "../../enum/ReferenciaConta";

interface ContaManualTableRowProps {
    conta: IConta;
    selecionado: boolean;
    toggleSelecionado: (uuid: string) => void;
}

const ContaManualTableRow = ({ conta, selecionado, toggleSelecionado }: ContaManualTableRowProps) => {
    const { dataBr } = useDataHora();
    const { real } = useMoeda();

    const isPedido = conta.referenciaTipo === ReferenciaConta.pedido;

    const renderTipo = () => {
        if (isPedido || conta.tipo === 'receber') {
            return <Chip label="A Receber" color="success" size="small" sx={{ fontWeight: 700, fontSize: '0.7rem' }} />;
        }
        return <Chip label="A Pagar" color="error" size="small" sx={{ fontWeight: 700, fontSize: '0.7rem' }} />;
    };

    const renderStatus = () => {
        if (isPedido) return <Typography variant="body2" color="text.disabled">-</Typography>;
        return (
            <Chip
                label={conta.pago ? 'Pago' : 'Pendente'}
                color={conta.pago ? 'success' : 'warning'}
                size="small"
                sx={{ fontWeight: 700, fontSize: '0.7rem' }}
            />
        );
    };

    return (
        <TableRow
            selected={selecionado}
            hover
            sx={{ '&:last-child td': { border: 0 } }}
        >
            <TableCell padding="checkbox" sx={{ pl: 2 }}>
                <Checkbox
                    checked={selecionado}
                    onChange={() => toggleSelecionado(conta.uuid)}
                    size="small"
                />
            </TableCell>
            <TableCell>
                {isPedido && conta.referenciaUuid && (
                    <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600, display: 'block', lineHeight: 1.2 }}>
                        #{conta.referenciaUuid.substring(0, 8).toUpperCase()}
                    </Typography>
                )}
                <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
                    {conta.descricao}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    {real(conta.valor)}
                </Typography>
            </TableCell>
            <TableCell>{renderTipo()}</TableCell>
            <TableCell align="center">
                <Typography variant="body2" color={conta.dataVencimento ? 'text.primary' : 'text.disabled'}>
                    {conta.dataVencimento ? dataBr(conta.dataVencimento) : '-'}
                </Typography>
            </TableCell>
            <TableCell align="center">{renderStatus()}</TableCell>
        </TableRow>
    );
};

export default ContaManualTableRow;
